import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";
import { MeModule } from "./MeModules.types";

// Catálogo operacional do tenant ativo para a sidebar do usuário logado.
// Endpoint: GET /v1/user/me/modules (AuthGuard; tenant resolvido pela sessão,
// nunca pelo cliente — ver docs/multi-tenant.md). Sem catálogo X.Y.Z próprio:
// o único caminho de erro modelado é 401 (sessão inválida), tratado
// globalmente pelo unauthorizedHandler do axios.
export const getMeModules = async (): Promise<MeModule[]> => {
  const response = await axiosGetData<MeModule[]>("v1/user/me/modules");
  return response;
};

export const useMeModulesQuery = (
  options?: Partial<UseQueryOptions<MeModule[], AxiosError>>,
) => {
  return useQuery<MeModule[], AxiosError>({
    queryKey: ["me", "modules"],
    queryFn: getMeModules,
    retry: false,
    throwOnError: false,
    ...options,
  });
};
